import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function NewContact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        reason: '',
        phone: '',
        message: ''
    });

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Construct the WhatsApp message with form data
        const message = `
      New Contact Form Submission:
      Name: ${formData.name}
      Email: ${formData.email}
      Reason for Contacting: ${formData.reason}
      Phone: ${formData.phone || 'Not provided'}
      Message: ${formData.message || 'No message provided'}
    `.trim();

        // Encode the message for the URL
        const encodedMessage = encodeURIComponent(message);

        // WhatsApp URL for the phone number +97125868431
        const whatsappUrl = `https://wa.me/+97125868431?text=${encodedMessage}`;

        // Open WhatsApp chat in a new tab/window
        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className='px-4 sm:px-6 md:px-10 py-10 sm:py-16 md:py-20 mt-3 sm:mt-5 flex flex-col md:flex-row relative'>
            {/* Form Section with Geometric Shapes */}
            <div className='w-full md:w-1/2  overflow-hidden'>
                {/* Geometric Shapes Background */}
                <div className="absolute inset-0 pointer-events-none">
                    {/* Circle 1 */}
                    <svg
                        className="absolute top-0 left-0 w-24 h-24 sm:w-32 sm:h-32 text-indigo-900 opacity-10"
                        viewBox="0 0 100 100"
                        fill="currentColor"
                    >
                        <circle cx="50" cy="50" r="50" />
                    </svg>
                    {/* Circle 2 */}
                    <svg
                        className="absolute bottom-10 right-0 w-32 h-32 sm:w-40 sm:h-40 text-blue-500 opacity-10"
                        viewBox="0 0 100 100"
                        fill="currentColor"
                    >
                        <circle cx="50" cy="50" r="50" />
                    </svg>
                    <svg
                        className="absolute bottom-40 right-5 w-16 h-16 sm:w-20 sm:h-20 text-gray-300 opacity-20 rotate-45"
                        viewBox="0 0 100 100"
                        fill="currentColor"
                    >
                        <polygon points="50,0 100,100 0,100" />
                    </svg>
                    {/* Triangle */}
                    <svg
                        className="absolute top-1/3 left-1/4 w-16 h-16 sm:w-20 sm:h-20 text-gray-300 opacity-20 rotate-45"
                        viewBox="0 0 100 100"
                        fill="currentColor"
                    >
                        <polygon points="50,0 100,100 0,100" />
                    </svg>
                    {/* Diagonal Line */}
                    {/* <svg
                        className="absolute inset-0 w-full h-full text-indigo-900 opacity-5"
                        viewBox="0 0 100 100"
                        stroke="currentColor"
                        strokeWidth="1"
                    >
                        <line x1="0" y1="100" x2="100" y2="0" />
                    </svg> */}
                </div>

                {/* Form Content */}
                <div className="relative z-10 px-3">
                    <h1 className='mb-4 sm:mb-5 text-xl sm:text-2xl text-indigo-900 font-medium'>
                        Connect with our Team
                    </h1>
                    <form className="space-y-4 sm:space-y-6" onSubmit={handleSubmit}>
                        {/* Input Fields (Responsive Grid) */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
                            <input
                                type="text"
                                name="name"
                                placeholder="Your Name*"
                                value={formData.name}
                                onChange={handleChange}
                                className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base bg-gray-50 bg-opacity-90"
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Email*"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base bg-gray-50 bg-opacity-90"
                                required
                            />
                            <input
                                type="text"
                                name="reason"
                                placeholder="Reason for Contacting*"
                                value={formData.reason}
                                onChange={handleChange}
                                className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base bg-gray-50 bg-opacity-90"
                                required
                            />
                            <input
                                type="text"
                                name="phone"
                                placeholder="Phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base bg-gray-50 bg-opacity-90"
                            />
                        </div>

                        {/* Textarea */}
                        <textarea
                            name="message"
                            placeholder="Message"
                            rows="4"
                            value={formData.message}
                            onChange={handleChange}
                            className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base bg-gray-50 bg-opacity-90"
                        ></textarea>

                        {/* Note */}
                        <p className="text-xs sm:text-sm text-gray-500">
                            <span className="text-red-500">*</span> indicates a required field
                        </p>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            className="w-full sm:w-auto px-10 sm:px-16 md:px-20 py-2 bg-indigo-900 text-white hover:bg-blue-800 transition text-sm sm:text-base"
                        >
                            Submit
                        </button>
                    </form>
                </div>
            </div>

            {/* Contact Info Section */}
            <div className='w-full md:w-1/2 flex justify-center items-center mt-8 md:mt-0'>
                <div className='flex flex-col items-start text-indigo-900 text-sm sm:text-base md:text-lg gap-y-3 sm:gap-y-4'>
                    <p className='flex text-black font-medium'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="gray" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-map-pin"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" /><path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" /></svg>
                        <span className='text-indigo-900 ms-2 sm:ms-3 text-start'>MW5 - Mussafah industrial city - Abu Dhabi - UAE</span>
                    </p>
                    <p className='flex text-black font-medium'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="gray" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-phone"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" /></svg>
                        <span className='text-indigo-900 font-medium ms-2 sm:ms-3'>+971 2586 8431</span>
                    </p>
                    <p className='flex text-black font-medium'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="gray" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-mail"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" /><path d="M3 7l9 6l9 -6" /></svg>
                        <span className='text-indigo-900 font-medium ms-2 sm:ms-3'>info@northernprokitchen.com</span>
                    </p>
                    {/* Social Media Icons */}
                    <div className="flex gap-3 sm:gap-4 justify-center md:justify-start w-full mt-4 sm:mt-5">
                        <Link
                            to="https://wa.me/971569186717"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-7 h-7 sm:w-8 sm:h-8 bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-indigo-900 cursor-pointer"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-brand-whatsapp"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
                                <path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />
                            </svg>
                        </Link>
                        <Link
                            to="https://www.linkedin.com/company/northern-professional-kitchen-equipment/about/?viewAsMember=true"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-7 h-7 sm:w-8 sm:h-8 bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-indigo-900 cursor-pointer"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-brand-linkedin"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M8 11v5" /><path d="M8 8v.01" /><path d="M12 16v-5" /><path d="M16 16v-3a2 2 0 1 0 -4 0" /><path d="M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z" /></svg>
                        </Link>
                        <Link
                            to="https://www.facebook.com/profile.php?id=61563070569694"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-7 h-7 sm:w-8 sm:h-8 bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-indigo-900 cursor-pointer"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-brand-facebook"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" /></svg>
                        </Link>
                        <Link
                            to="https://www.instagram.com/northern_professional_kitchen?igsh=cW11MmkzNmIzcnUw&utm_source=qr"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-7 h-7 sm:w-8 sm:h-8 bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-indigo-900 cursor-pointer"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-brand-instagram"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 8a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" /><path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" /><path d="M16.5 7.5v.01" /></svg>
                        </Link>
                    </div>
                    {/* ISO-ICV Image */}
                    <div className="flex w-full justify-center md:justify-start mt-2">
                        <img src="/assets/ISO-ICV.png" alt="ISO ICV Certification" className="h-20 sm:h-24 object-contain" />
                    </div>
                </div>
            </div>
        </div>
    );
}